<template>
  <div>
    <div class="row">
      <div class="col col-lg-8">
        <h1>About</h1>

        <p class="mt-5">
          Welcome to the Chamdor card payments portal.<br><br> In order to make use of this portal and pay for your
          online shopping order, please follow the card payment link options that you received in your order confirmation
          email, which will direct you to the payments page in order to make a
          payment using your credit/debit/cheque card  for your order.
        </p>
        <p>
         There is an EFT payment option. Details can be found in the order confirmation email. Goods will only be couriered once payment is cleared in our bank account
        </p>
        <p>
          For any other queries related to your orders , please email us on .<br />
        </p>

        <p>
          <a href="mailto:online@chamdor.com">online@chamdor.com</a>
        </p>

        <h6 class="mt-5 font-weight-bold">Links:</h6>

        <p>
          <a href="https://chamdor.com/pages/terms-and-condtions">Terms and Conditions</a>
        </p>

        <p>
          <a href="https://chamdor.com/pages/disclaimer">Disclaimer</a>
        </p>

        <p>
          <a href="https://chamdor.com/pages/privacy-policy">Privacy Policy</a>
        </p>

        <p>
          <a href="https://chamdor.com/pages/shipping-policy">Shipping Policy</a>
        </p>

        <p>
          <a href="https://chamdor.com/pages/returns-policy">Returns Policy</a>
        </p>

        <p>
          <a href="https://chamdor.com/policies/terms-of-service">Terms of Service</a>
        </p>

        <p>
          <a href="https://chamdor.com/policies/refund-policy">Refund policy</a>
        </p>

       
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},

  methods: {},

  data() {
    return {};
  },
};
</script>

<style>
</style>